import { render, staticRenderFns } from "./Stays.vue?vue&type=template&id=316f6080&"
import script from "./Stays.vue?vue&type=script&lang=js&"
export * from "./Stays.vue?vue&type=script&lang=js&"
import style0 from "./Stays.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports